/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentInvestigationControllerToolCallDetailQueryResponse, IncidentInvestigationControllerToolCallDetailPathParams } from "../../models/incidentAgentController/IncidentInvestigationControllerToolCallDetail";

function getIncidentInvestigationControllerToolCallDetailUrl(id: IncidentInvestigationControllerToolCallDetailPathParams["id"], toolCallId: IncidentInvestigationControllerToolCallDetailPathParams["toolCallId"]) {
  const res = { method: 'GET', url: `/api/v1/incident-agent/investigations/${id}/tool-calls/${toolCallId}/detail` as const }  
  return res
}

/**
 * {@link /api/v1/incident-agent/investigations/:id/tool-calls/:toolCallId/detail}
 */
export async function incidentInvestigationControllerToolCallDetail(id: IncidentInvestigationControllerToolCallDetailPathParams["id"], toolCallId: IncidentInvestigationControllerToolCallDetailPathParams["toolCallId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IncidentInvestigationControllerToolCallDetailQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getIncidentInvestigationControllerToolCallDetailUrl(id, toolCallId).url.toString(), ... requestConfig })  
  return res.data
}